export const listStudentsQuery = `
  query ListStudents($input: ListStudentsInput) {
    listStudents(input: $input) {
      code
      students {
        id
        companyId
        studentCode
        fullName
        programId
        gradeId
        streamId
        studentCategoryId
        academicYearId
        billingPeriodId
        enrollmentDate
        guardianPhone
        guardianEmail
        status
        version
      }
      totalElements
      totalPages
      currentPage
      pageSize
    }
  }
`;

export const getStudentQuery = `
  query GetStudent($input: GetStudentInput!) {
    getStudent(input: $input) {
      code
      student {
        id
        companyId
        studentCode
        fullName
        programId
        gradeId
        streamId
        studentCategoryId
        academicYearId
        billingPeriodId
        enrollmentDate
        guardianPhone
        guardianEmail
        status
        version
      }
    }
  }
`;

export const createStudentQuery = `
  mutation CreateStudent($input: CreateStudentInput!) {
    createStudent(input: $input) {
      code
      student {
        id
        companyId
        studentCode
        fullName
        programId
        gradeId
        streamId
        studentCategoryId
        status
      }
    }
  }
`;

export const updateStudentQuery = `
  mutation UpdateStudent($input: UpdateStudentInput!) {
    updateStudent(input: $input) {
      code
      student {
        id
        companyId
        studentCode
        fullName
        programId
        gradeId
        streamId
        studentCategoryId
        status
        version
      }
    }
  }
`;

export const withdrawStudentMutation = `
  mutation WithdrawStudent($input: StudentExitInput!) {
    withdrawStudent(input: $input) {
      code
      student {
        id
        fullName
        status
        version
      }
    }
  }
`;

export const graduateStudentMutation = `
  mutation GraduateStudent($input: StudentExitInput!) {
    graduateStudent(input: $input) {
      code
      student {
        id
        fullName
        status
        version
      }
    }
  }
`;

export const transferOutStudentMutation = `
  mutation TransferOutStudent($input: StudentExitInput!) {
    transferOutStudent(input: $input) {
      code
      student {
        id
        fullName
        status
        version
      }
    }
  }
`;
